export const content = {
  header: 'Feel Good Rhythm Skating in VR',
}

export const colors = {
  darkBlue: '#f1f1f1a4',
  spinnerBlue: '#f1f1f154',
  spinnerFlood: '#f1f1f1a4',
}
